/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CommonResponse } from '../model';
// @ts-ignore
import { CreateIndividualDOPRequest } from '../model';
// @ts-ignore
import { CreateIndividualDOPResponse } from '../model';
// @ts-ignore
import { DeviceTokenRequest } from '../model';
// @ts-ignore
import { IdentityHashResponse } from '../model';
// @ts-ignore
import { VerificationQuery } from '../model';
// @ts-ignore
import { VerificationQueryResponse } from '../model';
/**
 * IndividualUserApi - axios parameter creator
 * @export
 */
export const IndividualUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This inquiries if a specified email or name are verified. 
         * @summary Check verification status
         * @param {VerificationQuery} verificationQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkVerificationStatus: async (verificationQuery: VerificationQuery, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verificationQuery' is not null or undefined
            assertParamExists('checkVerificationStatus', 'verificationQuery', verificationQuery)
            const localVarPath = `/v1/entity/individual/verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = verificationQuery

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This creates a new individual entity for DOP flow. This new entity has verified status phone number. 
         * @summary Creates Individual Entity - DOP Flow
         * @param {CreateIndividualDOPRequest} createIndividualDOPRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndividualEntityForDop: async (createIndividualDOPRequest: CreateIndividualDOPRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createIndividualDOPRequest' is not null or undefined
            assertParamExists('createIndividualEntityForDop', 'createIndividualDOPRequest', createIndividualDOPRequest)
            const localVarPath = `/v1/entity/individual/dop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = createIndividualDOPRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns a hash value derived from an identity object. This value is from a stored value in our blockchain network.
         * @summary Identity fingerprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityFingerprint: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/hash`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This registers a device token on our DB. Each user will have many device tokens.
         * @summary Register a device token
         * @param {DeviceTokenRequest} deviceTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerDeviceToken: async (deviceTokenRequest: DeviceTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceTokenRequest' is not null or undefined
            assertParamExists('registerDeviceToken', 'deviceTokenRequest', deviceTokenRequest)
            const localVarPath = `/v1/entity/individual/device-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = deviceTokenRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation deletes a specified account data from Credify network.
         * @summary Removes Individual Entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeIndividualEntity: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/individual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IndividualUserApi - functional programming interface
 * @export
 */
export const IndividualUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IndividualUserApiAxiosParamCreator(configuration)
    return {
        /**
         * This inquiries if a specified email or name are verified. 
         * @summary Check verification status
         * @param {VerificationQuery} verificationQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkVerificationStatus(verificationQuery: VerificationQuery, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkVerificationStatus(verificationQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This creates a new individual entity for DOP flow. This new entity has verified status phone number. 
         * @summary Creates Individual Entity - DOP Flow
         * @param {CreateIndividualDOPRequest} createIndividualDOPRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIndividualEntityForDop(createIndividualDOPRequest: CreateIndividualDOPRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateIndividualDOPResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIndividualEntityForDop(createIndividualDOPRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns a hash value derived from an identity object. This value is from a stored value in our blockchain network.
         * @summary Identity fingerprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdentityFingerprint(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityHashResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdentityFingerprint(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This registers a device token on our DB. Each user will have many device tokens.
         * @summary Register a device token
         * @param {DeviceTokenRequest} deviceTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerDeviceToken(deviceTokenRequest: DeviceTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerDeviceToken(deviceTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation deletes a specified account data from Credify network.
         * @summary Removes Individual Entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeIndividualEntity(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeIndividualEntity(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IndividualUserApi - factory interface
 * @export
 */
export const IndividualUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IndividualUserApiFp(configuration)
    return {
        /**
         * This inquiries if a specified email or name are verified. 
         * @summary Check verification status
         * @param {VerificationQuery} verificationQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkVerificationStatus(verificationQuery: VerificationQuery, options?: any): AxiosPromise<VerificationQueryResponse> {
            return localVarFp.checkVerificationStatus(verificationQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * This creates a new individual entity for DOP flow. This new entity has verified status phone number. 
         * @summary Creates Individual Entity - DOP Flow
         * @param {CreateIndividualDOPRequest} createIndividualDOPRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndividualEntityForDop(createIndividualDOPRequest: CreateIndividualDOPRequest, options?: any): AxiosPromise<CreateIndividualDOPResponse> {
            return localVarFp.createIndividualEntityForDop(createIndividualDOPRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns a hash value derived from an identity object. This value is from a stored value in our blockchain network.
         * @summary Identity fingerprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityFingerprint(options?: any): AxiosPromise<IdentityHashResponse> {
            return localVarFp.getIdentityFingerprint(options).then((request) => request(axios, basePath));
        },
        /**
         * This registers a device token on our DB. Each user will have many device tokens.
         * @summary Register a device token
         * @param {DeviceTokenRequest} deviceTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerDeviceToken(deviceTokenRequest: DeviceTokenRequest, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.registerDeviceToken(deviceTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation deletes a specified account data from Credify network.
         * @summary Removes Individual Entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeIndividualEntity(options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.removeIndividualEntity(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IndividualUserApi - interface
 * @export
 * @interface IndividualUserApi
 */
export interface IndividualUserApiInterface {
    /**
     * This inquiries if a specified email or name are verified. 
     * @summary Check verification status
     * @param {VerificationQuery} verificationQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualUserApiInterface
     */
    checkVerificationStatus(verificationQuery: VerificationQuery, options?: AxiosRequestConfig): AxiosPromise<VerificationQueryResponse>;

    /**
     * This creates a new individual entity for DOP flow. This new entity has verified status phone number. 
     * @summary Creates Individual Entity - DOP Flow
     * @param {CreateIndividualDOPRequest} createIndividualDOPRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualUserApiInterface
     */
    createIndividualEntityForDop(createIndividualDOPRequest: CreateIndividualDOPRequest, options?: AxiosRequestConfig): AxiosPromise<CreateIndividualDOPResponse>;

    /**
     * This returns a hash value derived from an identity object. This value is from a stored value in our blockchain network.
     * @summary Identity fingerprint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualUserApiInterface
     */
    getIdentityFingerprint(options?: AxiosRequestConfig): AxiosPromise<IdentityHashResponse>;

    /**
     * This registers a device token on our DB. Each user will have many device tokens.
     * @summary Register a device token
     * @param {DeviceTokenRequest} deviceTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualUserApiInterface
     */
    registerDeviceToken(deviceTokenRequest: DeviceTokenRequest, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This operation deletes a specified account data from Credify network.
     * @summary Removes Individual Entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualUserApiInterface
     */
    removeIndividualEntity(options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

}

/**
 * IndividualUserApi - object-oriented interface
 * @export
 * @class IndividualUserApi
 * @extends {BaseAPI}
 */
export class IndividualUserApi extends BaseAPI implements IndividualUserApiInterface {
    /**
     * This inquiries if a specified email or name are verified. 
     * @summary Check verification status
     * @param {VerificationQuery} verificationQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualUserApi
     */
    public checkVerificationStatus(verificationQuery: VerificationQuery, options?: AxiosRequestConfig) {
        return IndividualUserApiFp(this.configuration).checkVerificationStatus(verificationQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This creates a new individual entity for DOP flow. This new entity has verified status phone number. 
     * @summary Creates Individual Entity - DOP Flow
     * @param {CreateIndividualDOPRequest} createIndividualDOPRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualUserApi
     */
    public createIndividualEntityForDop(createIndividualDOPRequest: CreateIndividualDOPRequest, options?: AxiosRequestConfig) {
        return IndividualUserApiFp(this.configuration).createIndividualEntityForDop(createIndividualDOPRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns a hash value derived from an identity object. This value is from a stored value in our blockchain network.
     * @summary Identity fingerprint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualUserApi
     */
    public getIdentityFingerprint(options?: AxiosRequestConfig) {
        return IndividualUserApiFp(this.configuration).getIdentityFingerprint(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This registers a device token on our DB. Each user will have many device tokens.
     * @summary Register a device token
     * @param {DeviceTokenRequest} deviceTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualUserApi
     */
    public registerDeviceToken(deviceTokenRequest: DeviceTokenRequest, options?: AxiosRequestConfig) {
        return IndividualUserApiFp(this.configuration).registerDeviceToken(deviceTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation deletes a specified account data from Credify network.
     * @summary Removes Individual Entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualUserApi
     */
    public removeIndividualEntity(options?: AxiosRequestConfig) {
        return IndividualUserApiFp(this.configuration).removeIndividualEntity(options).then((request) => request(this.axios, this.basePath));
    }
}
